import React from 'react';
import { ForgeList } from '@tylertech/forge-react';
import PropTypes from 'prop-types';
import { useNavigationLinks } from './navigationLinks.js';
import NavItem from './NavDrawer/NavItem.js';
import ExpandingNavItem from './NavDrawer/ExpandingNavItem.js';
import { getAccessCondition } from '../reusable/reusableFunctions.js';
import { useUser } from '../../contexts/userContext.js';

const SettingsPanel = ({
  open,
  selected,
  setSelected,
  organizationAccessIcons,
}) => {
  const { settingsItems } = useNavigationLinks();
  const { user } = useUser();
  if (!open) return <></>;

  return (
    <aside style={{ padding: '0.5rem' }}>
      <ForgeList navlist={true}>
        {settingsItems.map(({ title, iconName, subItems, name, to }) => {
          return subItems ? (
            <ExpandingNavItem
              itemName={title}
              iconName={iconName}
              subItems={subItems}
              key={title}
              setSelected={setSelected}
              selected={selected}
              organizationAccessIcons={organizationAccessIcons}
            />
          ) : getAccessCondition(name, organizationAccessIcons, user) && (
            <NavItem
              itemName={title}
              iconName={iconName}
              to={to}
              key={title}
              setSelected={setSelected}
              selected={title === selected}
            />
          );
        })}
      </ForgeList>
    </aside>
  );
};

SettingsPanel.propTypes = {
  open: PropTypes.bool,
  selected: PropTypes.string,
  setSelected: PropTypes.func,
  organizationAccessIcons: PropTypes.array,
};

export default SettingsPanel;
